export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILED = "UPLOAD_FILE_AILED";
export const UPLOAD_FILE_RESET = "UPLOAD_FILE_RESET";
export const FETCH_FILE = "FETCH_FILE";
export const FETCH_FILE_SUCCESS = "FETCH_FILE_SUCCESS";
export const FETCH_FILE_FAILED = "FETCH_FILE_FAILED";
export const FETCH_DATA_RESET = "FETCH_DATA_RESET";
export const FETCH_DATA_NOTIFIED = "FETCH_DATA_NOTIFIED";
export const NEW_REPORT_FILE = "NEW_REPORT_FILE";
export const NEW_REPORT_FILE_SUCCESS = "NEW_REPORT_FILE_SUCCESS";
export const NEW_REPORT_FILE_FAILED = "NEW_REPORT_FILE_FAILED";
export const NEW_REPORT_FILE_RESET = "NEW_REPORT_FILE_RESET";
export const NEW_REPORT_FILE_NOTIFIED = "NEW_REPORT_FILE_NOTIFIED";
export const UPLOAD_XML_ZIP_FILE = "UPLOAD_XML_ZIP_FILE";
export const UPLOAD_XML_ZIP_FILE_SUCCESS = "UPLOAD_XML_ZIP_FILE_SUCCESS";
export const UPLOAD_XML_ZIP_FILE_FAILED = "UPLOAD_XML_ZIP_FILE_FAILED";
export const UPLOAD_XML_ZIP_FILE_NOTIFIED = "UPLOAD_XML_ZIP_FILE_NOTIFIED";
export const UPLOAD_XML_ZIP_FILE_RESET = "UPLOAD_XML_ZIP_FILE_RESET";
